import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FileService {
  figureCache: { [url: string]: Blob } = {};

  parseName(value: string) {
    return value
      .toLowerCase()
      .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "")
      .trim()
      .replace(/\s\s+/g, " ")
      .replace(/ /g, "-");
  }

  download(file: any, fileName = "file.txt", fileType = "application/json") {
    let blob: Blob = new Blob([file], {
      type: fileType,
    });

    let url = window.URL.createObjectURL(blob);
    let anchorNode = document.createElement("a");

    anchorNode.href = url;
    anchorNode.download = fileName;

    document.body.appendChild(anchorNode),
      anchorNode.click(),
      window.URL.revokeObjectURL(url),
      window.setTimeout(function () {
        anchorNode.remove();
      }, 100);
  }

  downloadS3File(url: string, filename: string, onComplete?: () => void): void {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      onComplete?.();
    }, 100);
  }

  downloadS3FileWithProgress(
    url: string,
    filename: string,
    onComplete?: () => void,
    onError?: () => void,
  ): Subscription {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      onComplete?.();
    }, 100);

    return new Subscription(() => {
      if (document.body.contains(a)) {
        document.body.removeChild(a);
      }
    });
  }
}
